import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pl-2 text-sm leading-tight font-regular text-gray-600" }
const _hoisted_2 = { class: "px-2 text-sm font-medium leading-tight text-right" }


export default /*#__PURE__*/_defineComponent({
  __name: 'CopdUhbModifiedAnthonisenCriteriaMeasurementReading',
  props: {
  label: {
    type: String,
    required: true
  },
  value: {
    type: String,
    required: true
  },
  alert: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dl", {
    class: _normalizeClass(["flex justify-between items-center", { 'bg-alert-200 rounded py-1': __props.alert }])
  }, [
    _createElementVNode("dt", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("dd", _hoisted_2, _toDisplayString(__props.value), 1)
  ], 2))
}
}

})